var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.move}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.item.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }